import { render, staticRenderFns } from "./form_header.vue?vue&type=template&id=15d639dc&scoped=true"
import script from "./form_header.vue?vue&type=script&lang=js"
export * from "./form_header.vue?vue&type=script&lang=js"
import style0 from "./form_header.vue?vue&type=style&index=0&id=15d639dc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d639dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d639dc')) {
      api.createRecord('15d639dc', component.options)
    } else {
      api.reload('15d639dc', component.options)
    }
    module.hot.accept("./form_header.vue?vue&type=template&id=15d639dc&scoped=true", function () {
      api.rerender('15d639dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/form/components/form_header.vue"
export default component.exports